<ion-item class="ion-no-padding pad-wrapper" (click)="onExpand()">
	<ion-label class="txt20px">{{ to.label }}</ion-label>
	<ion-icon slot="end" [name]="this.sectionCollapsed ? 'caret-down-outline' : 'caret-up'"></ion-icon>
</ion-item>

<div [ngClass]="this.sectionCollapsed ? 'collapsed' : ''">
	<ng-container #fieldComponent></ng-container>
</div>